import type { Point } from '@ipfabric/utils';
import { pipe } from 'fp-ts/lib/pipeable';
import type { EdgeMouseEvent, NodeMouseEvent } from '../events/GraphAppEvents';

export const getGraphMouseEventPosition = (
  mouseEvent: NodeMouseEvent | EdgeMouseEvent,
): Point =>
  pipe(mouseEvent.data.originalEvent as PointerEvent, (e) => ({
    // fallback to layerX bc FF returns 0 in offset coordinates.
    // this is not concern in graphs while 0,0 point is blocked by breadcrumbs
    // but pls do not copy this naive approach to places where 0,0 is triggerable
    x: (e.offsetX || e.layerX) ?? 0,
    y: (e.offsetY || e.layerY) ?? 0,
  }));
